import React from 'react';

import { draftStatusLabels } from '../../locale/ru/draftStatus';
import { DraftStatus } from '../../model/draft';
import { Channel } from '../../model/skill';

import Status from './Status';

interface Props<TChannel extends Channel> {
    status: DraftStatus;
    channel: TChannel;
}

const DRAFT_STATUS_COLOR = 'green';

export function DraftStatusComponent<T extends Channel>({ status, channel }: Props<T>) {
    try {
        const message =
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (draftStatusLabels as any)?.[channel]?.[status] ||
            draftStatusLabels[Channel.AliceSkill][DraftStatus.InDevelopment];
        return <Status color={DRAFT_STATUS_COLOR} message={message} />;
    } catch (error) {
        console.error('@DraftStatusComponent ', status, channel, error);
    }
    return null;
}
